/**
 * The mark a provider carries beside its name on the operator pages.
 *
 * Integration Credentials drew the first letter of the name and Provider Rate
 * Limits the first two characters, so ATTOM Data read "A" on one page and "AT"
 * on the next, and the Integrations list drew a status icon in the same place
 * (r3-op-cons-13). One helper now draws it: up to two initials, upper case.
 * Status is not part of the mark; each surface states status in its badge.
 */

/**
 * Up to two initials of a provider name, upper case: "ATTOM Data" -> "AD",
 * "Coinbase Prime" -> "CP", "Experian" -> "EX", "CU*Answers" -> "CA". A name
 * with no letters or digits has no mark.
 */
export function providerMark(name: string): string {
  const words = name.split(/[^A-Za-z0-9]+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
}

/** The mark tile. Decorative: the provider name beside it is the accessible text. */
export function ProviderMark({ name }: { name: string }) {
  return (
    <div
      className="w-10 h-10 bg-elevated rounded-sm flex items-center justify-center flex-shrink-0"
      aria-hidden="true"
      data-provider-mark=""
    >
      <span className="text-sm font-sans font-semibold text-primary">{providerMark(name)}</span>
    </div>
  );
}
